import React, { useState } from "react";
import "./login.css";
import { Link, useNavigate } from "react-router";
import { config } from "../ConfigFile/Config";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";

export default function Login() {
  const baseUrl = config.baseUrl;
  const [formData, setFormData] = useState({
    email: "",
    password: "",
  });
  const [showPassword, setShowPassword] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errors, setErrors] = useState({});
  const navigate = useNavigate();
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const validateForm = () => {
    let newErrors = {};
    if (!formData.email) {
      newErrors.email = "Email is required";
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = "Invalid email format";
    }
    if (!formData.password) {
      newErrors.password = "Password is required";
    } else if (formData.password.length < 6) {
      newErrors.password = "Password must be at least 6 characters";
    }
    return newErrors;
  };

  // const token = localStorage.getItem("token");
  // let tokenRole = null;

  // if (token) {
  //   try {
  //     const tokenPayload = JSON.parse(atob(token.split(".")[1]));
  //     tokenRole = tokenPayload.role;
  //     console.log("Decoded Role:", tokenRole);
  //   } catch (err) {
  //     console.log("Invalid Token Format");
  //   }
  // }

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length !== 0) {
      setErrors(formErrors);
      return;
    }
    setIsLoading(true);
    try {
      const { data } = await axios({
        url: `${baseUrl}/api/website/user/login`,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: formData,
      });

      if (data?.success) {
        toast.success("Login success");
        localStorage.setItem("token", data.token);
        const tokenPayload = JSON.parse(atob(data.token.split(".")[1]));
        const tokenRole = tokenPayload.role;
        tokenRole?.map((item) => {
          localStorage.setItem("role", JSON.stringify(tokenRole));
          if (item === "careers") {
            navigate("/admin/careers");
          } else if (item === "franchise") {
            navigate("/admin/franchise");
          } else if (item === "appointment") {
            navigate("/admin/appointment");
          } else {
            toast.error("Invalid role assigned");
          }
        });
      } else {
        toast.error(data?.message || "Invalid Credental");
        setErrors({ api: data?.message || "Login failed" });
      }
      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      toast.error("Invalid Email address or password");
      setErrors({ api: error?.response?.data?.message || "Server error" });
    } finally {
      setIsLoading(false);
    }
  };
  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="main-form-desgin">
      <ToastContainer />
      <div className="form-container">
        <h2>Login</h2>
        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Email:</label>
            <input
              type="email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              placeholder="Enter your email"
              disabled={isLoading}
            />
            {errors.email && <span className="error">{errors.email}</span>}
          </div>
          <div className="form-group password-container">
            <div className="d-flex justify-content-between align-items-center">
              <label>Password:</label>
              {/* <Link to="/forgot-password">forget password</Link> */}
            </div>
            <input
              type={showPassword ? "text" : "password"}
              name="password"
              value={formData.password}
              onChange={handleChange}
              placeholder="Enter your password"
              disabled={isLoading}
            />
            <span
              className="password-toggle-icon"
              onClick={togglePasswordVisibility}
            >
              {showPassword ? <FaEye /> : <FaEyeSlash />}
            </span>
            {errors.password && (
              <span className="error">{errors.password}</span>
            )}
          </div>
          <button type="submit" className="button" disabled={isLoading}>
            {isLoading ? (
              <span className="loader">Please Wait...</span>
            ) : (
              "Login"
            )}
          </button>
        </form>
      </div>
    </div>
  );
}
